import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Icon } from "../../icons";

export const RegisterContainer = styled("div")(({ theme }) => ({
  position: 'relative',
  marginTop: theme.space._1000,
  width: "100%",
  maxWidth: "1440px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: theme.space._700,
  paddingBottom: "12.5rem"
}));

export const StyledBlueSpan = styled("span")(({ theme }) => ({
  color: theme.colors["blue.400"]
}));

export const RegisterStepsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._600,
  width: "min-content",
  alignSelf: "strech",

  "@media (max-width: 600px)": {
    padding: `0 ${theme.space._400}`,
    width: "100%",
  },
}));

export const CTABackAndForthContainer = styled("div")(({ theme }) => ({
  display: "flex",
  paddingTop: theme.space._200,
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.space._600,
  alignSelf: "stretch",
}));


export const CTAForthContainer = styled("div")(({ theme }) => ({
  display: "flex",
  paddingTop: theme.space._200,
  justifyContent: "flex-end",
  alignItems: "center",
  gap: theme.space._600,
  alignSelf: "stretch",
}));

export const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  paddingTop: theme.space._100,
  justifyContent: "center",
  alignItems: "center"
}));

export const ButtonLabel = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.short
}));

export const ButtonIcon = styled(Icon)(({ theme }) => ({
  width: theme.space._450,
  height: theme.space._450,
}));
